export default __webpack_public_path__ + "static/media/yellowOnboardingGraphic2.8747ab50.svg";